export const ClawPassIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.50585 1.6723C7.7691 1.24478 6.91312 1 6 1C3.23857 1 1 3.23857 1 6C1 8.76143 3.23857 11 6 11C8.76143 11 11 8.76143 11 6C11 5.09317 10.7586 4.24272 10.3365 3.50942"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.98751 4.01172C7.98751 4.01172 7.14059 6.27284 6.75009 6.66337C6.35956 7.05389 5.72639 7.05389 5.33586 6.66337C4.94534 6.27284 4.94534 5.63967 5.33586 5.24914C5.72639 4.85862 7.98751 4.01172 7.98751 4.01172Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
